<template>
  <BlocksRestaurantReviewsFeaturedCard v-for="post in restaurants"
    :key="post.restaurant?.id"
    :post="post"
    :restaurant="post.restaurant"
  />
</template>

<script setup>
const props = defineProps({
  restaurants: Array
})
</script>
